export default __webpack_public_path__ + "static/media/Optimized-pexels-cottonbro-5483070 (1).ef6ed6c3.jpg";